import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'

loadFonts()

// ResizeObserver loop xatosini oldini olish uchun (Vuetify'ning mashhur yassi xatoligi)
const OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      window.requestAnimationFrame(() => {
        if (!Array.isArray(entries) || !entries.length) return;
        callback(entries, observer);
      });
    });
  }
};
const app = createApp(App)

router.beforeEach((to, from, next) => {
  store.dispatch('showLoader')
  next()
})

router.afterEach(() => {
  setTimeout(() => {
    store.dispatch('hideLoader')
  }, 1000)
})


  app
  .use(router)
  .use(store)
  .use(vuetify)
  .mount('#app')